import React from 'react';

import './adBox.scss';

import http from 'Demora/http';

class singleAd extends React.Component {
	constructor(props, context) {
		super(props, context);

		this.clickOnAd = this.clickOnAd.bind(this);

		this.state = {
			a: props.a,
		};
	}

	clickOnAd() {
		if (!this.props.clientId) {
			return;
		}

		http.post('/data/a1/' + this.state.a.id, {
			url: window.location.href,
			pos: this.props.pos,
			clientId: this.props.clientId,
			boxId: this.props.boxId,
		});
	}

	escapeHtml(unsafe) {
		return (
			unsafe
				//		.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
		);
		//		.replace(/"/g, '&quot;')
		//		.replace(/'/g, '&#039;');
	}

	render() {
		let a = this.state.a;

		return (
			<div className='ali'>
				<a
					href={this.escapeHtml(a.website_url)}
					onClick={this.clickOnAd}
					target='_blank'
				>
					<div className='a'>{this.escapeHtml(a.title)}</div>
					<div className='b'>
						{this.escapeHtml(a.desc1)} {this.escapeHtml(a.desc2)}
					</div>
					<div className='c'>{this.escapeHtml(a.url_to_show)}</div>
				</a>
			</div>
		);
	}
}

export default singleAd;
